module.exports = __webpack_public_path__ + "static/media/product-onoiwa-detail.a3e7e62a.png";